// extracted by mini-css-extract-plugin
export var banner = "_pc-0";
export var settingRow = "_pc-2";
export var titleIcon = "_pc-1";